import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query AvgVotesForOperator($operatorId: Int!) {
  avgVoteBySkillForOperator(operatorId: $operatorId) {
     id,
     name,
     avgVote
  }
}`;

function getAvgIndicativeVotesForOperator(operatorId) {
  return apollo.client.query({
    query,
    variables: {
      operatorId: parseInt(operatorId, 10),
    },
    fetchPolicy: 'network-only',
  }).then((data) => data.data.avgVoteBySkillForOperator);
}

export default getAvgIndicativeVotesForOperator;
